import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { IconButton, TextField, makeStyles } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { cloneDeep } from 'lodash';
import { useState, useEffect } from 'react';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import { useRecoilValue } from 'recoil';
import trI18n from '@/common/utils/trI18n';

export default function ChatBotInput({
    isModePreview,
    listOptionsAutocomplete,
    onSubmitSendMessage,
    onChangeOptionsAutocomplete,
    usingAI,
    isEnableBtnSend,
    messages,
    chatbotSettings,
    isEnableMsgInput,
    listTagFieldOfSelectedCategory,
    setListTagFieldOfSelectedCategory,
    getMessage
}) {
    const [isStepEnd, setIsStepEnd] = useState(false)

    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [chatBotSetting, setChatBotSetting] = useState({});
    const [textInput, setTextInput] = useState('');

    const isEnableChatBotAIMode = usingAI;

    useEffect(() => {
        if (!isModePreview) {
            setChatBotSetting(chatbotSettings);
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (chatBotSetting?.sendIcon !== previewSetting?.sendIcon) {
                setChatBotSetting(previewChatBotSetting => ({
                    ...previewChatBotSetting,
                    sendIcon: previewSetting?.sendIcon
                }));
            }
        }
    }, [previewSetting]);
    
    useEffect(() => {
        if (!Utils.isEmptyArray(messages)) {
            let isEnd = false;
            const lastMessage = messages[messages.length - 1];

            switch (lastMessage.messageType) {
                case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONFIRM_ISSUES_RESOLVED:
                    const msg_CBOTMSG006 = lastMessage.content.find(arr => arr.msgKey === trI18n('CBOTMSG006'));
                    if (msg_CBOTMSG006 && messages.length > 2) { // check is not first msg
                        isEnd = true;
                    }
                    break;
                case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.THE_END:
                case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN:
                case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT:
                    isEnd = true;
                    break;
                case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FORM_QA_IN_CHATBOT:
                    if (messages.length > 2) {
                        const messageFinished = messages[messages.length - 2];
                        if ([Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONFIRM_ISSUES_RESOLVED, Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.QA_FORM_OPTION_LIVE_CHAT].includes(messageFinished.messageType)) {
                            isEnd = true;
                        }
                    }
                    break;
                case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.QA_FORM_OPTION_LIVE_CHAT:
                    if (messages.length > 2) {
                        const messageFinished = messages[messages.length - 2];
                        if ([Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FORM_QA_IN_CHATBOT, Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONFIRM_ISSUES_RESOLVED].includes(messageFinished.messageType)) {
                            isEnd = true;
                        }
                    }
                    break;
                default:
                    break;
            }

            setIsStepEnd(isEnd);

            if (isEnd) {
                setTextInput('');
                setListTagFieldOfSelectedCategory([]);
            }
        }
    }, [messages]);

    const isLoadingTagField = () => {
        if (Utils.isEmptyArray(messages)) {
            return false;
        }
        const lastMessage = messages[messages.length - 1];
    
        return lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LOADING_GET_LIST_TAG_FIELD;
    }

    const isSelectedCategory = () => {
        if (Utils.isEmptyArray(messages)) {
            return false;
        }

        const lastMessage = messages[messages.length - 1];
        if (
            [
                Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM,
                Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FORM_QA_IN_CHATBOT,
                Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.QA_FORM_OPTION_LIVE_CHAT,
                Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN,
                Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE
            ].includes(lastMessage?.messageType)
        ) {
            return false;
        }

        const messageClone = cloneDeep(messages);
        const MessageRevered = messageClone.reverse();

        const indexLastMSGCat = MessageRevered.map((item) => item?.messageType).indexOf(Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY);

        const listMSGAfterChooseCat = MessageRevered.slice(0, indexLastMSGCat);

        const messageTypeClearCat = [
            Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.THE_END
        ];

        const isClearCategorySeleted = listMSGAfterChooseCat.filter((item) => messageTypeClearCat.includes(item?.messageType));

        return Utils.isEmptyArray(isClearCategorySeleted);
    }

      const onChangeChatInput = e => {
        setTextInput(e.target.value);
    };

    const clearTextInput = () => {
        setTextInput('');
    }

    const checkPermissionSentAI = () => {
        return isEnableChatBotAIMode && isSelectedCategory() && !Utils.isEmptyString(textInput) && isEnableBtnSend &&!isLoadingTagField();
    }

    const onEnterTextInput = async e => {
        if (e.key === 'Enter' && !e.shiftKey) {

            e.preventDefault();
            if (!checkPermissionSentAI()) {
                return false;
            }
            
            onSendMessage();
        }
    };

    const onSendMessage =  () => {
        
        if (!checkPermissionSentAI()) {
            return;
        }
        onSubmitSendMessage(textInput);
        clearTextInput();
    };

    let msgPlaceholder = '';
    if (isEnableChatBotAIMode && isSelectedCategory()) {
        msgPlaceholder = getMessage('bot_chat_input_placeholder_ai');
    } else if (listTagFieldOfSelectedCategory.length <= 0) {
        // placeholder for step 1. display category
        msgPlaceholder = getMessage('bot_chat_input_placeholder');
    } else {
        // step 2 to end.
        msgPlaceholder = getMessage('bot_chat_input_placeholder_normal');
    }

    const placeholder = msgPlaceholder;

    // const classes = useStyles();

    return (
        <div className="chat-input-wrapper">
            <div className="groupForm-chat">
                <div className="group-fild">
                    <div className="formField" data-cy="chat-form-input-field">
                        <Autocomplete
                            getOptionLabel={option => option?.name || ''}
                            disableClearable
                            disablePortal={false}
                            disabled={!isEnableMsgInput || isStepEnd}
                            freeSolo
                            className="form-control"
                            options={listOptionsAutocomplete}
                            clearOnBlur={false}
                            onChange={(_, value) => onChangeOptionsAutocomplete(_, value)}
                            inputValue={textInput}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    multiline
                                    maxRows={15}
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        className: 'input-chatbot-autocomplete'
                                    }}
                                    onChange={onChangeChatInput}
                                    placeholder={isStepEnd ? '' : (isEnableMsgInput && placeholder)}
                                    onKeyPress={async e => await onEnterTextInput(e)}
                                    style={{
                                        background: `${!isEnableMsgInput || isStepEnd ? "#F2F3F5" : "#fff"}`,
                                        maxHeight: '215px',
                                        overflowY: 'auto'
                                    }}
                                />
                            )}
                            renderOption={option => (
                                <OverFlowTooltipWithTabsMui
                                    value={option?.name}
                                    className="item-options-acmp"
                                />
                            )}
                            noOptionsText={trI18n('COMMSG001')}
                        />
                    </div>
                </div>
                <div
                    className={`groupBtn-send groupBtn-send-${
                        checkPermissionSentAI() ? 'enable' : 'disabled'
                    }`}
                >
                    <IconButton
                        className="btnSend"
                        onClick={async () => await onSendMessage(textInput)}
                    >
                        <img
                            className={`send-message-icon-${
                                checkPermissionSentAI() ? 'enable' : 'disable'
                            }`}
                            src={
                                chatBotSetting?.sendIcon && 
                                chatBotSetting?.sendIcon !==
                                    Constant.SETTING_CHAT_BOT.SEND_LOGO
                                    ? chatBotSetting?.sendIcon
                                    : '/assets/image/icon-send.svg'
                            }
                            alt="#"
                        />
                    </IconButton>
                </div>
            </div>
        </div>
    );
}
